import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpActionState } from '../../main/pages/users/userslisting/store/users-listing.reducers';
import { AuthState } from '../reducers/auth.reducer';
import * as storeKeys from './../store-key.config';



export const authFeatureSelector = createFeatureSelector<AuthState>(storeKeys.auth_key);
export const userDataSelector = createSelector(authFeatureSelector, state => state.userData);
export const isUserDataFetched = createSelector(authFeatureSelector, state => !!state.userData);
export const isTenantOwner = createSelector(userDataSelector, state => state?.tenant_owner === true);
export const userRoles = createSelector(userDataSelector, state => state?.roles);
export const verifyOtpInProgress = createSelector(authFeatureSelector, state => state.verifyOtpInProgress);
export const hasPermissionInRole = (role: string, permission: string) => createSelector(userDataSelector, state => state?.roles.find(x => x.name === role)?.permissions.some(x => x.name === permission) != false);
export const userGroups = createSelector(userDataSelector, user => user?.groups || []);
export const authFormLoader = createSelector(authFeatureSelector, state => state.loading);
export const isThirdPartyLogin = createSelector(authFeatureSelector, state => state.isThirdPartyLogin);
export const isIframeAbleLogin = createSelector(authFeatureSelector, state => state.iframeableLoginIn);
export const crmData = createSelector(authFeatureSelector, (state) => state.crmData);
export const loadingUserDataStatus = createSelector(authFeatureSelector, (state) => state.userDataFetchStatus);
export const isLoggedIn = createSelector(authFeatureSelector, state => state.loginSuccess);
export const refreshTokenInProgress = createSelector(authFeatureSelector, state => state.refreshSessionInProgress === HttpActionState.Busy);
export const authError = createSelector(authFeatureSelector, state => state.error);
